<div class="add-company-modal">
  <h3 class="add-company-modal-label text-h5-s text-md-h4-s color-black" [class.container-v2]="isMobileSmDown()">
    добавить свою компанию
  </h3>

  <div class="add-company-modal-company-search">
    <sd-input-autocomplete
      placeholder="найти по ИНН, ОРГН или названию"
      [items]="searchResult()"
      [loading]="searchCompanyLoading()"
      [disabled]="addCompanyLoading()"
      (changeInput)="onInputChange($event)"
      (setInput)="onInputSelect($event)"
      [itemTemplate]="itemTemplate"
    ></sd-input-autocomplete>

    <ng-template #itemTemplate let-item>
      <div class="item">
        <div class="text-b2-s-500 color-black">{{ item.label }}</div>
        @if (item.value) {
          <div class="text-c2-l-500 color-black-400">
            @if (item.value.vatID) {
              <span>ИНН: {{ item.value.vatID }}</span>
            }
            @if (item.value.debtorKPP) {
              <span>, КПП: {{ item.value.debtorKPP }}</span>
            }
            @if (item.value.contactAddress) {
              <span>, {{ item.value.contactAddress }}</span>
            }
          </div>
        }
      </div>
    </ng-template>
  </div>

  @if (inputSelectedValue()) {
    <div class="add-company-modal-button" [class.container-v2]="isMobileSmDown()">
      <button
        sdButton
        class="btn-add-company"
        [fullWidth]="true"
        [size]="'l'"
        [theme]="'primary'"
        [loading]="addCompanyLoading() || userCompaniesLoading()"
        [disabled]="addCompanyLoading() || userCompaniesLoading()"
        (click)="onAddCompanyBtnClick()"
      >
        добавить компанию
      </button>
    </div>
  }
</div>
